import React, { Component } from 'react'
import Logo from 'components/Logo'
import { FormattedMessage, injectIntl } from 'react-intl'
import messages from './messages'

class ErrorBoundary extends Component {
  state = {
    error: null,
    trace: null,
  }

  static getDerivedStateFromError(error) {
    return { error: error }
  }

  componentDidCatch(error, info) {
    this.setState({ trace: info.componentStack })
  }

  render() {
    const { intl } = this.props

    if (this.state.error) {
      const formatMessage = intl.formatMessage

      return (
        <div>
          <nav className="bg-primary">
            <div className="max-w-screen-xl mx-auto flex items-center justify-between flex-wrap font-medium">
              <div className="flex items-center flex-shrink-0 text-white mr-6 py-4 px-2">
                <a href={formatMessage(messages.url)}>
                  <Logo className="pl-3" />
                </a>
              </div>
            </div>
          </nav>

          <div className="flex justify-center items-center p-12">
            <div className="max-w-xl w-full">
              <FormattedMessage
                {...messages.errorMessage}
                values={{
                  h1: chunk => <h1 className="text-2xl">{chunk}</h1>,
                  p: chunk => <p className="my-4">{chunk}</p>,
                  span: chunk => <span>{chunk}</span>,
                  phone_link: chunk => (
                    <a href={'tel:' + formatMessage(messages.phone_number)}>{chunk}</a>
                  ),
                  email_link: chunk => (
                    <a className="text-primary" href={'mailto:' + formatMessage(messages.email)}>
                      {chunk}
                    </a>
                  ),
                  link_home_page: chunk => (
                    <a className="text-primary" href={formatMessage(messages.url)}>
                      {chunk}
                    </a>
                  ),
                  email: formatMessage(messages.email),
                  phone_number: formatMessage(messages.phone_number),
                  url: formatMessage(messages.url),
                }}
              />
              <div className="mt-12 border border-gray-200 p-4">
                <div className="font-bold mb-2">Error</div>
                <p>{this.state.trace}</p>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

// Since hooks like useIntl can only be used in function components, injectIntl is the way to provide intl context to class components.
// React does not currently support getDerivedStateFromError or componentDidCatch in function components
export default injectIntl(ErrorBoundary)
